import IncentiveBadge from './IncentiveBadge';

export default IncentiveBadge;
